// import { logoUrl } from "config/config"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button, Col, Row } from "react-bootstrap"
import { ChevronDown, ChevronUp } from "react-bootstrap-icons"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
import { useTranslation } from "react-i18next"
import { DropModel } from "../../api/drop.api"
import { useAppDispatch } from "../../app/hooks"
import aramex from "../../assets/ShippingCompaniesIcons/aramex.svg"
import dhl from "../../assets/ShippingCompaniesIcons/dhl.svg"
import fedex from "../../assets/ShippingCompaniesIcons/fedex.svg"
import usps from "../../assets/ShippingCompaniesIcons/usps.svg"
import { SearchBar, SelectFilterColums } from "../../components/Tables/Columns"
import CustomTotal from "../../components/Tables/CustomTotal"
import pageListRenderer from "../../components/Tables/PageListRenderer"
import sizePerPageOptionRenderer from "../../components/Tables/SizePerPageOptionRenderer"
import { dropParcels } from "../../store/drop.store"

let suiteFilter: any

function DropTable({ drops }: { drops: DropModel[] }) {
    const { t } = useTranslation()
    const onFilter = (value: string | number, id: string, subId: string) => {
        if (!value) value = ""
        if (id === "suite") suiteFilter(value)
    }
    const [parcelToDrop, setParcelToDrop] = useState(0)
    const [removeParcelToDrop, setRemoveParcelToDrop] = useState(0)
    const [parcelsToDrop, setParcelsToDrop] = useState([] as number[])

    const dispatch = useAppDispatch()
    const handleAction = (action: string, suiteId: number) => {
        switch (action) {
            case "Drop":
                return dispatch(dropParcels({ suite_id: suiteId, parcel_ids: parcelsToDrop }))
            default:
                break
        }
    }

    useEffect(() => {
        setParcelsToDrop([...parcelsToDrop, parcelToDrop])
    }, [parcelToDrop])

    useEffect(() => {
        setParcelsToDrop([...parcelsToDrop?.filter((p) => p !== removeParcelToDrop)])
    }, [removeParcelToDrop])

    const parcelsColumns = [
        {
            dataField: "id",
            text: t(""),
            sort: true
        },
        {
            dataField: "suite",
            text: t("Suite_Id"),
            filter: textFilter({
                getFilter: (filter: any) => {
                    suiteFilter = filter
                }
            }),
            style: {
                width: 250
            }
        },
        {
            dataField: "ParcelSuites.length",
            text: t("Parcels to Drop"),
            sort: true
        }
    ]
    const onSelect = (row: Record<string, any>, isSelect: any) => {
        if (isSelect) {
            setParcelsToDrop([...parcelsToDrop, row?.id])
        } else {
            setParcelsToDrop(parcelsToDrop?.filter((sp) => sp !== row?.id))
        }
    }
    const handleSelectAll = (isSelect: any, rows: Record<string, any>[]) => {
        if (isSelect) {
            setParcelsToDrop(rows?.map((sp) => sp?.id))
        } else {
            setParcelsToDrop([])
        }
    }
    const selectRow: any = {
        mode: "checkbox",
        clickToSelect: true,
        onSelect: onSelect,
        onSelectAll: handleSelectAll,
        selectColumnPosition: "left"
    }
    const expandRow = {
        renderer: (row: Record<string, any>) => {
            const columns = [
                {
                    dataField: "created_at",
                    text: t("Date"),
                    sort: true,
                    formatter: (cell: number, row: Record<string, any>) => {
                        if (cell) return moment(cell).format("DD MMM yyyy")
                    }
                },
                {
                    dataField: "id",
                    text: t("Parcel No."),
                    style: {
                        color: "#1E88E5"
                    }
                },
                {
                    dataField: "uuid",
                    text: t("Parcel ID"),
                    style: {
                        width: 230,
                        color: "#1E88E5"
                    }
                },
                {
                    dataField: "shipping_company_id",
                    text: t("Shipping"),
                    formatter: (cell: string | number) => {
                        switch (cell) {
                            case 1:
                                return (
                                    <img
                                        className={"w-25"}
                                        width="120"
                                        height="80"
                                        src={aramex}
                                        alt="aramex_icon"
                                    />
                                )
                            case 2:
                                return (
                                    <img className={"w-25"} width="120" height="80" src={dhl} alt="dhl_icon" />
                                )
                            case 5:
                                return (
                                    <img
                                        className={"w-25"}
                                        width="120"
                                        height="80"
                                        src={fedex}
                                        alt="fedex_icon"
                                    />
                                )
                            case 6:
                                return (
                                    <img
                                        className={"w-25"}
                                        width="120"
                                        height="80"
                                        src={usps}
                                        alt="usps_icon"
                                    />
                                )
                            default:
                                break
                        }
                    }
                }
                // {
                //     dataField: "",
                //     text: t("Actions"),
                //     formatter: (cell: number, row: Record<string, any>) => {
                //         return (
                //             <Dropdown className="actions-menu">
                //                 <Dropdown.Toggle
                //                     variant="primary"
                //                     id="dropdown-basic"
                //                     size={"sm"}
                //                     className="py-0"
                //                 >
                //                     {t("Actions")}
                //                 </Dropdown.Toggle>

                //                 <Dropdown.Menu>
                //                     {["Drop"].map((action) => (
                //                         <Dropdown.Item
                //                             className="py-0"
                //                             onClick={() =>
                //                                 handleAction(action, row?.id)
                //                             }
                //                         >
                //                             {t(action)}
                //                         </Dropdown.Item>
                //                     ))}
                //                 </Dropdown.Menu>
                //             </Dropdown>
                //         )
                //     }
                // }
            ]
            return (
                <>
                    {parcelsToDrop?.length > 0 && (
                        <Button
                            className="float-end mx-4 my-2"
                            onClick={() => handleAction("Drop", row?.ParcelSuites[0]?.suite_id)}>
                            {t("Drop Selected")}
                        </Button>
                    )}
                    <BootstrapTable
                        keyField="uuid"
                        data={row?.ParcelSuites?.map((ps: Record<string, any>) => ps.parcel)}
                        columns={columns}
                        wrapperClasses="inner-table my-3 mx-4 "
                        headerClasses="header-class"
                        bordered={false}
                        noDataIndication={t("No_Record")}
                        rowClasses="inner-table-row"
                        condensed={true}
                        selectRow={selectRow}
                    />
                </>
            )
        },
        showExpandColumn: true,
        expandByColumnOnly: true,
        onlyOneExpanding: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }: { isAnyExpands: boolean }) => {
            return <></>
        },
        expandColumnRenderer: ({ expanded }: { expanded: boolean }) => {
            if (expanded) {
                setParcelToDrop(0)
                setRemoveParcelToDrop(0)
                setParcelsToDrop([])
                return <ChevronUp color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
            }
            return <ChevronDown color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
        }
    }

    const options = {
        sizePerPage: 50,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        sizePerPageOptionRenderer,
        showTotal: true,
        pageListRenderer,
        paginationTotalRenderer: CustomTotal
    }

    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {parcelsColumns && (
                <ToolkitProvider
                    keyField="suite"
                    data={drops}
                    columns={parcelsColumns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "DropTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => (
                        <div className="table-container my-4">
                            <Row className="search mx-2">
                                <Col xs={12} sm={12} md={12} lg={8} className="d-flex px-4">
                                    <SelectFilterColums
                                        preFilteredRows={props.baseProps.data}
                                        id="suite"
                                        text={t("Suite_Id")}
                                        {...props.searchProps}
                                        onFilterClick={onFilter}
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={4} className="d-flex justify-content-end px-4">
                                    <SearchBar {...props.searchProps} />
                                </Col>
                                <Col className="d-none">
                                    <ExportCSVButton {...props.csvProps}>Export</ExportCSVButton>
                                </Col>
                            </Row>
                            <Row className="table-data my-3">
                                <Col>
                                    <BootstrapTable
                                        expandRow={expandRow}
                                        {...props.baseProps}
                                        wrapperClasses="table-wrapper my-3"
                                        headerClasses="header-class"
                                        bordered={false}
                                        noDataIndication={t("No_Record")}
                                        filter={filterFactory()}
                                        rowClasses="custom-table-row"
                                        condensed={true}
                                        pagination={paginationFactory(options)}
                                        sort={{
                                            dataField: "created_at",
                                            order: "desc"
                                        }}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default DropTable
